import React, { useState, useEffect } from 'react';
import { useLabs } from '../../hooks/useLabs';
import './Labs.css';

export const RouteView = ({ routeId }) => {
  const { routes, userProgress, setSelectedLevel } = useLabs();
  const [route, setRoute] = useState(null);

  useEffect(() => {
    const found = routes.find(r => r.id === routeId);
    setRoute(found);
  }, [routeId, routes]);

  if (!route) {
    return <div className="route-view loading">Cargando ruta...</div>;
  }

  const progress = userProgress[routeId] || {};
  const completedCount = progress.niveles?.filter(n => n.completado).length || 0;
  const totalCount = route.niveles?.length || 0;
  const progressPercent = (completedCount / totalCount) * 100;

  const isLevelUnlocked = (index) => {
    // Primer nivel siempre desbloqueado
    if (index === 0) return true;
    
    // Verificar si hay progreso registrado
    if (!progress.niveles || progress.niveles.length === 0) {
      return false; // Solo el primer nivel si no hay progreso
    }
    
    // Buscar el nivel anterior por index
    const previousLevel = progress.niveles?.find((n, i) => {
      const currentRouteLevel = route.niveles[index - 1];
      return currentRouteLevel && n.id === currentRouteLevel.id;
    });
    
    // Desbloquear si el nivel anterior está completado
    return previousLevel?.completado || false;
  };

  return (
    <div className="route-view">
      <div className="route-header">
        <div className="route-header-content">
          <div className="route-icon">{route.icono}</div>
          <div>
            <h1>{route.titulo}</h1>
            <p>{route.descripcion}</p>
            <div className="route-stats">
              <span>{completedCount}/{totalCount} niveles completados</span>
              <span>Duración estimada: {route.duracion_estimada_horas} horas</span>
              <span className={`difficulty-badge ${route.dificultad.toLowerCase()}`}>
                {route.dificultad}
              </span>
            </div>
          </div>
        </div>

        <div className="route-progress">
          <div className="progress-bar large">
            <div 
              className="progress-fill"
              style={{ width: `${progressPercent}%` }}
            ></div>
          </div>
          <span>{Math.round(progressPercent)}% completado</span>
        </div>
      </div>

      <div className="levels-list">
        {route.niveles?.map((level, index) => {
          const levelProgress = progress.niveles?.[index];
          const isCompleted = levelProgress?.completado;
          const isUnlocked = isLevelUnlocked(index);

          return (
            <div 
              key={level.id}
              className={`level-item ${isCompleted ? 'completed' : ''} ${!isUnlocked ? 'locked' : ''}`}
              onClick={() => isUnlocked && setSelectedLevel(level.id)}
            >
              <div className="level-number">
                <span>{index + 1}</span>
              </div>

              <div className="level-info">
                <h4>{level.titulo}</h4>
                <p className="level-scenario">{level.escenario.substring(0, 80)}...</p>
                <div className="level-objectives">
                  {level.objetivos?.slice(0, 2).map((obj, i) => (
                    <span key={i} className="objective-badge">{obj}</span>
                  ))}
                  {level.objetivos?.length > 2 && (
                    <span className="objective-badge">+{level.objetivos.length - 2}</span>
                  )}
                </div>
              </div>

              <div className="level-status">
                {isCompleted && (
                  <span className="status-icon completed">✓</span>
                )}
                {!isUnlocked && (
                  <span className="status-icon locked">🔒</span>
                )}
                {isUnlocked && !isCompleted && (
                  <span className="status-icon in-progress">⏳</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
